import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { InventoryValueBadgeProps } from "./InventoryValueBadge.types"

const icon = faIcon({ name: "money-bills", style: "regular" })

export default function InventoryValueBadge(props: InventoryValueBadgeProps) {
    const { value, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    // The badge is always shown — a missing value renders as the zero-currency value.
    const formatted = formatCurrency(value ?? 0)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Inventory value\n${formatted}`}>
            {formatted}
        </Badge>
    )
}
